import { B400, N0, N200, R300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

import { ColumnCss } from '../../styles';

import { FlexRowAlignedCentered } from './options-adder/OptionsAdderStyled';

export const LevelConfigInputHeader = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: ${token('color.text.subtlest', N200)};
    margin: 8px 0;
`;

export const LevelConfigInputDescription = styled.div`
    font-size: 11px;
    font-weight: 400;
    line-height: 16px;
    color: ${token('color.text.subtlest', N200)};
    margin-top: 4px;
`;

export const InputWithHeaderAndDescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const TopBarWrapper = styled.div`
    ${FlexRowAlignedCentered};
    justify-content: space-between;
    padding: 12px 0;

    button[data-testid^='settings-btn'] {
        right: 1px;
    }
`;

export const BottomSection = styled.div`
    background: ${token('utility.UNSAFE.transparent', N0)};

    .buttons {
        margin-top: 16px;
        margin-right: 4px;
        height: 40px;
        float: right;
    }
`;

export const FullWidthLine = styled.div`
    width: 100%;
    height: 2px;
    background: ${token('color.background.neutral.bold', N200)};
    opacity: 0.2;
    margin-top: ${token('space.025')};
`;

export const OptionDisabledWarningWrapper = styled.div`
    margin: 24px 0;
`;

export const PreviewWarningSectionWrapper = styled.div`
    margin: 24px 0;
    margin-bottom: 16px;
`;

export const AddBulkOptionsInfoText = styled.div`
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
    color: ${token('color.text.subtlest', N200)};
    margin-top: 4px;
`;

export const AddBulkOptionsWarningText = styled.p`
    color: ${token('color.text.danger', R300)};
`;

export const LevelsInfoWrapper = styled.div`
    ${ColumnCss}
`;

export const TranslateTextWrapper = styled.div`
    ${FlexRowAlignedCentered};
    cursor: pointer;
`;

export const TranslateText = styled.div`
    color: ${token('color.text.accent.blue', B400)};
`;

export const LocaleSelectWrapper = styled.div`
    #preview-locale-select {
        width: 72.5%;
    }
`;

export const SettingsBodyWrapper = styled.div`
    min-height: 30px;
`;

const TopBarHeight = '66px';
const TopBarWithLicenseHeight = '132px';
const BottomBarWithFullWithLineHeight = '60px';

export const FieldConfigContent = styled.div<{ isLicenseValid: boolean }>`
    height: calc(${({ isLicenseValid }) => (isLicenseValid ? `100vh - ${TopBarHeight}` : `100vh - ${TopBarWithLicenseHeight}`)} - ${BottomBarWithFullWithLineHeight});
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;

export const PositionedElement = styled.div<{ position: string }>`
    position: ${({ position }) => position};
`;
